import { FieldArrayRenderProps } from 'formik';
import { ReactElement, useCallback } from 'react';
import i18n from '../../../../../../../../i18n';
import { NumericInputWidget } from '../../../../../../shared/component/widget/numeric-input';
import { SwitchInput } from '../../../../../../shared/component/widget/switch-input';
import { MultipassSchedulePostActionInput } from '../multipass-schedule-post-action-input';
import { MultipassScheduleWeldLibraryInput } from '../multipass-schedule-weld-library-input';
import { useManageMultipassScheduleFieldArray } from '../multipass.hooks';

interface MultipassScheduleIndividualFieldsProps {
  fieldArrayProps: FieldArrayRenderProps;
  currentPass: number;
  disabled?: boolean;
  presentingEl?: HTMLElement;
  forceFullScreenModals?: boolean;
}

const MultipassScheduleIndividualFields = (
  props: MultipassScheduleIndividualFieldsProps
): ReactElement => {
  const {
    fieldArrayProps,
    currentPass,
    disabled,
    presentingEl,
    forceFullScreenModals,
  } = props;
  useManageMultipassScheduleFieldArray(fieldArrayProps);
  const getScheduleFieldName = useCallback(
    (fieldName: string) => {
      return `schedule[${currentPass}].${fieldName}`;
    },
    [currentPass]
  );

  return (
    <>
      <NumericInputWidget
        label={i18n.t('welding:multipass_schedule_header_start_offset')}
        name={getScheduleFieldName('startOffsetX')}
        disabled={disabled}
        requireNegative={true}
      />
      <NumericInputWidget
        label={i18n.t('welding:multipass_schedule_header_end_offset')}
        name={getScheduleFieldName('endOffsetX')}
        disabled={disabled}
        requireNegative={true}
      />
      <NumericInputWidget
        label={i18n.t(
          'welding:multipass_schedule_header_perpendicular_to_path'
        )}
        name={getScheduleFieldName('perpendicularToPathY')}
        disabled={disabled}
        requireNegative={true}
      />
      <NumericInputWidget
        label={i18n.t('welding:multipass_schedule_header_torch_offset')}
        name={getScheduleFieldName('stickoutZ')}
        disabled={disabled}
        requireNegative={true}
      />
      <NumericInputWidget
        label={i18n.t('welding:multipass_schedule_header_travel_angle')}
        name={getScheduleFieldName('travelAngle')}
        disabled={disabled}
        requireNegative={true}
      />
      <NumericInputWidget
        label={i18n.t('welding:multipass_schedule_header_work_angle')}
        name={getScheduleFieldName('workAngle')}
        disabled={disabled}
        requireNegative={true}
      />
      <SwitchInput
        label={i18n.t('welding:multipass_schedule_header_reverse_path')}
        name={getScheduleFieldName('reversePath')}
        disabled={disabled}
      />
      <MultipassScheduleWeldLibraryInput
        name={getScheduleFieldName('weldLibrary')}
        disabled={disabled}
        presentingEl={presentingEl}
        isFullScreen={forceFullScreenModals}
      />
      <MultipassSchedulePostActionInput
        name={getScheduleFieldName('postActions')}
        disabled={disabled}
        presentingEl={presentingEl}
        isFullScreen={forceFullScreenModals}
      />
    </>
  );
};

export { MultipassScheduleIndividualFields };
